import { Box, LinearProgress, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Document, PDFViewer, Page, View } from '@react-pdf/renderer';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as ROUTES from '../../../router/Routes';
import Modal from '../../../widgets/modals/Modal';
import ContainerTemplate from '../../../widgets/template/Container';
import { stylesDocPdf } from '../../pdfs';
import FooterPdf from '../../pdfs/FooterPdf';
import TablaFamiliaresPdf from './pdf/FamiliaresPdf';

// Create Document Component
const FamiliaresPdf = () => {
  const familiaresStore = Redux.useSelector((state) => state.familiares);
  const seccionesStore = Redux.useSelector((state) => state.secciones);

  const [loadingDoc, setLoadingDoc] = React.useState(true);

  const sec = seccionesStore.all.find(
    (el) => el.id === familiaresStore.params.idSeccion,
  );

  console.log(seccionesStore.all);
  console.log(familiaresStore.params.idSeccion);
  console.log(sec);

  // const seccion = ''
  const seccion = `${sec.nivelAcademico.nivelAcademico.abrev} SECCION ${sec.nombre}`;

  return (
    <ContainerTemplate
      active={ROUTES.familiaresPdf}
      routes={[ROUTES.controlEstudios, ROUTES.familiares]}
    >
      <Grid container spacing={1}>
        <Grid item md={12}>
          <PDFViewer
            style={{
              width: '100%',
              height: '80vh',
              zIndex: 50,
            }}
            showToolbar={true}
          >
            <Document title={seccion} onRender={() => setLoadingDoc(false)}>
              <Page size="A4" style={stylesDocPdf.page}>
                {/* <FooterPdf /> */}
                <View
                  style={{ flex: 1, ...stylesDocPdf.section, margin: '20pt' }}
                >
                  <TablaFamiliaresPdf
                    data={familiaresStore.all}
                    seccion={seccion}
                  />
                </View>
                <FooterPdf />
              </Page>
            </Document>
          </PDFViewer>
        </Grid>
        <Modal open={loadingDoc}>
          <Box sx={{ width: '100%' }}>
            <Typography variant="h6" sx={{ textAlign: 'center' }}>
              Generando lista...
            </Typography>
            <LinearProgress />
            <Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>
              Procesando la cantidad {familiaresStore.all.length} familiares
            </Typography>
            <Typography sx={{ textAlign: 'center' }}>
              Este proceso puede que tarde entre 1 a 3 minutos para completa,
              por favor espere.
            </Typography>
          </Box>
        </Modal>
      </Grid>
    </ContainerTemplate>
  );
};

export default FamiliaresPdf;
